import {withErrorBoundary} from './error-boundary';

export const wrapWithErrorBoundary = <T>(componentsMap: T): T => {
  const entriesWithBoundary = Object.entries(componentsMap).map(
    ([key, component]) => [key, withErrorBoundary(component)]
  );

  return Object.fromEntries(entriesWithBoundary) as T;
};
